import { gsap } from 'gsap';

export const MAX_SCALE_ON_HOVER = 1.1;
export const MAX_SCALE_ON_SELECTED = 1.1;

export function scaleUpDown(el: HTMLDivElement, { animate, shouldScale }: { animate: boolean; shouldScale: boolean }) {
    gsap.killTweensOf(el);
    const scaleTarget = shouldScale ? MAX_SCALE_ON_SELECTED : 1;

    if (!animate) {
        gsap.set(el, { '--hoverS': scaleTarget });
        return;
    }

    gsap.to(el, {
        '--hoverS': scaleTarget,
        duration: 0.18,
        ease: 'power1.out',
        overwrite: 'auto',
    });
}

export function hoverBounce(el: HTMLDivElement, { animate, shouldScale }: { animate: boolean; shouldScale: boolean }) {
    gsap.killTweensOf(el, '--hoverS');

    const scaleTarget = shouldScale ? MAX_SCALE_ON_HOVER : 1;

    if (!animate) {
        gsap.set(el, { '--hoverS': scaleTarget });
        return;
    }

    gsap.to(el, {
        '--hoverS': scaleTarget,
        duration: 0.8,
        ease: 'elastic.out(1.2, 0.3)',
        overwrite: 'auto',
    });
}

export function flipCard(el: HTMLDivElement, { animate, face }: { animate: boolean; face: 'up' | 'down' }) {
    gsap.killTweensOf(el, '--flip');
    gsap.to(el, {
        '--flip': face === 'up' ? '180deg' : '0deg',
        duration: animate ? 0.45 : 0,
        ease: 'power2.out',
        overwrite: 'auto',
    });
}

export function initializeState(
    card: HTMLElement,
    cardContainer: HTMLElement,
    { face, hovered, canSelect }: { face: 'up' | 'down'; hovered: boolean; canSelect: boolean },
) {
    gsap.set(card, {
        '--flip': face === 'up' ? '180deg' : '0deg',
        '--hoverS': hovered ? MAX_SCALE_ON_HOVER : 1,
    });
    gsap.set(cardContainer, {
        '--hoverS': canSelect ? MAX_SCALE_ON_SELECTED : 1,
    });
}
